"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var StickyHeader = /** @class */ (function (_super) {
    __extends(StickyHeader, _super);
    function StickyHeader() {
        var _this = _super.call(this, constants_1.DATA_HEADER) || this;
        _this.scrollListener = function () {
            if (window.scrollY >= _this.headerTopHeight) {
                _this.header.classList.add(constantsClasses_1.CLASS_STICKY);
            }
            else {
                _this.resetHeader();
            }
            if (window.scrollY <= _this.headerTopHeight) {
                _this.resetHeader();
            }
        };
        if (!_this.getElement())
            return _this;
        _this.header = _this.getElement();
        _this.headerTop = _this.getChildElement("[".concat(constants_1.DATA_HEADER_TOP, "]"));
        _this.headerBottom = _this.getChildElement("[".concat(constants_1.DATA_HEADER_BOTTOM, "]"));
        // Fire functions
        _this.stickyHeader();
        // Resize
        window.addEventListener('resize', function () {
            _this.stickyHeader();
        });
        return _this;
    }
    StickyHeader.prototype.stickyHeader = function () {
        this.resetHeader();
        this.headerTopHeight = this.headerTop.offsetHeight;
        var mql = window.matchMedia('(min-width: 992px)');
        if (mql.matches == true) {
            var headerOffset = this.headerBottom.getBoundingClientRect();
            var topOffset = headerOffset.top;
            // Initially add sticky class if page was scrolled down and refreshed
            if (topOffset <= 0) {
                this.header.classList.add(constantsClasses_1.CLASS_STICKY);
            }
            // On Scroll
            document.addEventListener('scroll', this.scrollListener, true);
        }
        else {
            document.removeEventListener('scroll', this.scrollListener, true);
        }
    };
    StickyHeader.prototype.resetHeader = function () {
        if (this.header.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.header.classList.remove(constantsClasses_1.CLASS_STICKY);
        }
    };
    return StickyHeader;
}(AbstractComponent_1.default));
exports.default = StickyHeader;
